import React, { Suspense } from 'react';

import { DataLayerWhere } from '@/modules/cart/services/data-layer-events/add-to-cart';
import { Button } from '@/modules/common/components/Button';
import { W2BRetailLocationPrefsProvider } from '@/modules/common/context/W2BRetailLocationPrefsContext';
import AskQuestionModal from '@/modules/product/components/modal/AskQuestionModal';
import FindAStore from '@/modules/product/components/modal/FindAStore/FindAStore';
import { DataLayerFeature } from '@/modules/product/services/data-layer-events/add-to-wishlist';

import { BrandResultMohawk } from '@/gql/__generated/graphql.types';

export const BrandHeroButtons = ({ brandData }: { brandData?: BrandResultMohawk | null }) => {
  return (
    <div className="flex flex-wrap gap-3 border-t border-[#F2F2F2] pt-4 lg:border-t-0 lg:pt-6">
      <Suspense>
        <W2BRetailLocationPrefsProvider>
          <FindAStore
            brandData={brandData}
            feature={DataLayerFeature.Brand}
            where={DataLayerWhere.Hero}
          >
            <Button size="m">Where to buy</Button>
          </FindAStore>
          <AskQuestionModal brandData={brandData}>
            <Button size="m">Ask a question</Button>
          </AskQuestionModal>
        </W2BRetailLocationPrefsProvider>
      </Suspense>
    </div>
  );
};
